import FormularioNovo from './FormularioNovo';

export default FormularioNovo;